import React from "react";

import { format, parse } from "date-fns";

interface Props {
  time: string;
  format: string;
}

function isValidDate(d: Date): boolean {
  return !isNaN(d.getTime());
}

export function parseTime(time: string): Date {
  const withMilli = parse(time, "HH:mm:ss.SSSX", new Date());
  if (isValidDate(withMilli)) return withMilli;

  const justSeconds = parse(time, "HH:mm:ssX", new Date());
  if (isValidDate(justSeconds)) return justSeconds;

  const noTimezone = parse(time, "HH:mm:ss", new Date());
  if (isValidDate(noTimezone)) return noTimezone;

  const noSeconds = parse(time, "HH:mm", new Date());
  if (isValidDate(noSeconds)) return noSeconds;

  throw new Error(`${time} can't be parsed to a Date.`);
}

/**
 * Parses Time values from graphql, and formats it using date-fns. If `time` is
 * unparseable, it will not throw an error but will display "Invalid time".
 */
const TimeFormat: React.FC<Props> = ({ time, format: formatString }) => {
  try {
    const inJSDate = parseTime(time);
    const formatted = format(inJSDate, formatString);
    return <>{formatted}</>;
  } catch (e) {
    console.error(e);
    return <>Invalid time</>;
  }
};

export default TimeFormat;
